import SubmissionFormInnerPageLayout from './SubmissionFormInnerPageLayout';

export default SubmissionFormInnerPageLayout;
